import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { VisualComponent } from '../base/Visual.component';
import { VisualType } from '../VisualType';

@Component({
  selector: 'pbir-visual__error',
  templateUrl: './ErrorVisual.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ErrorVisualComponent extends VisualComponent {
}

export namespace ErrorVisual {
  export const type = new VisualType('error', ErrorVisualComponent, {
    className: 'error',
    visualOptions: {},
    canReuse: true
  });
}
